export default function raiseFileUpload(params) {
   this.processFileInput({}, file => {
       this.dsClear();
       const prefix = params.prefix;
       this.temporaryData = {file: file};
       this.readFile({prefix: prefix});
   });
}